import { Navigate } from 'react-router-dom';
import { authClient } from '../lib/authClient';
import { useAdmin } from '../context/AdminContext';

export default function AdminRoute({ children }) {
  const { data: session, isPending } = authClient.useSession();
  const { isAdmin } = useAdmin();

  if (isPending) return null;
  if (!session?.user) return <Navigate to="/sign-in" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
